import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import * as React from "react";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = React.useState<number | null>(0);

  const faqs = [
    {
      question: "ليش التحدي مجاني؟",
      answer: "لأنه أول وآخر مرة بنقدمه مجاناً. هدفنا نساعد أكبر عدد من الناس يبدأوا رحلتهم في عالم التداول بشكل صحيح واحترافي.",
    },
    {
      question: "هل في مخاطر؟",
      answer: "أكيد، التداول فيه مخاطر زي أي نشاط استثماري. لكن بنعلّمك كيف تديرها بشكل صحيح وتقلل من احتمالية الخسارة من خلال استراتيجيات مجربة وإدارة رأس المال.",
    },
    {
      question: "هل لازم أودع فلوس؟",
      answer: "الشرط الوحيد هو فتح حساب تداول جديد من خلالنا وإيداع 100$ كحد أدنى. هذا المبلغ يبقى ملكك وتستخدمه في التداول الحقيقي بعد التدريب.",
    },
    {
      question: "كم الوقت المطلوب يومياً؟",
      answer: "حوالي 30 دقيقة فقط يومياً. بنعرف إنك مشغول، لذلك صممنا التحدي بحيث يكون مناسب لجدولك اليومي.",
    },
    {
      question: "هل التحدي مناسب للمبتدئين؟",
      answer: "نعم تماماً! التحدي مصمم خصيصاً للمبتدئين. بنبدأ معك من الصفر ونوصلك للاحتراف خطوة بخطوة.",
    },
    {
      question: "متى يبدأ التحدي؟",
      answer: "التحدي يبدأ فور تسجيلك وتأكيد بياناتك. سيتم التواصل معك خلال 24 ساعة لإرشادك بالخطوات التالية.",
    },
  ];

  return (
    <section className="relative py-24 bg-gradient-to-br from-[#000000] to-[#0A1E3F]/50 overflow-hidden">
      {/* Background Glow */}
      <div className="absolute top-1/4 right-0 w-96 h-96 bg-[#CFAE58] rounded-full blur-[150px] opacity-10"></div>
      <div className="absolute bottom-1/4 left-0 w-96 h-96 bg-[#0A1E3F] rounded-full blur-[150px] opacity-10"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            الأسئلة <span className="text-[#CFAE58]">الشائعة</span> 
          </h2>
        </motion.div>

        {/* FAQ Accordion */}
        <div className="max-w-4xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="relative"
            >
              <div
                className={`bg-gradient-to-br from-[#0A1E3F]/30 to-transparent backdrop-blur-sm border-2 rounded-2xl overflow-hidden transition-all duration-300 ${
                  openIndex === index
                    ? "border-[#CFAE58]/50 shadow-2xl shadow-[#CFAE58]/10"
                    : "border-[#CFAE58]/20 hover:border-[#CFAE58]/40"
                }`}
              >
                {/* Question */}
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full text-right p-6 flex items-center justify-between gap-4 group"
                >
                  <span className="text-xl text-white group-hover:text-[#CFAE58] transition-colors flex-1">
                    {faq.question}
                  </span>
                  <motion.div
                    animate={{ rotate: openIndex === index ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <ChevronDown className="w-6 h-6 text-[#CFAE58]" />
                  </motion.div>
                </button>

                {/* Answer */}
                <motion.div
                  initial={false}
                  animate={{
                    height: openIndex === index ? "auto" : 0,
                    opacity: openIndex === index ? 1 : 0,
                  }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <div className="px-6 pb-6 pt-0">
                    <div className="border-t border-[#CFAE58]/20 pt-4">
                      <p className="text-gray-300 text-lg leading-relaxed">{faq.answer}</p>
                    </div>
                  </div>
                </motion.div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
